const stateMutator = {
    /* A function that takes in a state and an array of objects. It then loops through the array of objects
    and if the object has a value it sets the state to that value. If the object does not have a value
    it sets the state to the opposite of what it was. */
    mutate: (state: any, keys: Array<{ key: string, value?: any }>) => {
        let newState = state
        for (let i = 0; i < keys.length; i++) {
            if (Object.entries(keys[i]).length > 1) {
                newState[keys[i].key] = keys[i].value
            } else {
                newState[keys[i].key] = !newState[keys[i].key]
            }
        }
        return newState
    }
}
export default stateMutator